
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';


@Component({
  selector: 'app-regatta-carousel',
  imports: [
    CarouselComponent
  ],
  templateUrl: './regatta-carousel.component.html',
  styleUrls: ['./regatta-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegattaCarouselComponent {

  public tiles: CarouselTile[] = [
    // {
    //   img: {
    //     src: 'assets/img/md/pboot2.webp',
    //     width: 1120,
    //     height: 742,
    //     alt: 'P-Boot Regatta',
    //     srcset: [
    //       'assets/img/xs/pboot2.webp 688w',
    //       'assets/img/sm/pboot2.webp 912w',
    //       'assets/img/md/pboot2.webp 1120w',
    //       'assets/img/lg/pboot2.webp 1360w',
    //       'assets/img/xl/pboot2.webp 2320w',
    //     ],
    //     sizes: ['90vw'],
    //     priority: true,
    //   }
    // },
    {
      img: {
        src: 'assets/img/pboot7.jpg',
        // width: 5400,
        // height: 3155,
        alt: 'P-Boot Regatta',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        // loading: 'lazy',
        priority: true,
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/ausklang-2015-1.jpg',
    //     // width: 1120,
    //     // height: 630,
    //     alt: 'Cat Ausklang im YSTM',
    //     //style: 'width:100%;height:100%;object-fit:cover;object-position:50% 60%;',
    //     objectPosition: '50% 60%',
    //     // srcset: [
    //     //   'assets/img/xs/ausklang-2015-1.webp 688w',
    //     //   'assets/img/sm/ausklang-2015-1.webp 912w',
    //     //   'assets/img/md/ausklang-2015-1.webp 1120w',
    //     //   'assets/img/lg/ausklang-2015-1.webp 1360w',
    //     //   'assets/img/xl/ausklang-2015-1.webp 2320w',
    //     // ],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    {
      img: {
        src: 'assets/img/auftakt-2024-1.jpg',
        // width: 1120,
        // height: 630,
        alt: 'Cat Auftakt im YSTM',
        //style: 'width:100%;height:100%;object-fit:cover;object-position:50% 60%;',
        objectPosition: '50% 60%',
        // srcset: [
        //   'assets/img/xs/ausklang-2015-1.webp 688w',
        //   'assets/img/sm/ausklang-2015-1.webp 912w',
        //   'assets/img/md/ausklang-2015-1.webp 1120w',
        //   'assets/img/lg/ausklang-2015-1.webp 1360w',
        //   'assets/img/xl/ausklang-2015-1.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/dart2.jpg',
        // width: 5400,
        // height: 4050,
        alt: 'Dart-Treff im YSTM',
        //breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
        //priority: true,
      }
    },
    {
      img: {
        src: 'assets/img/h-jolle2.jpg',
        // width: 5400,
        // height: 3542,
        alt: 'H-Jolle im Regatta-Modus',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
        // priority: true,
      }
    },
    {
      img: {
        src: 'assets/img/pboot1.jpg',
        // width: 1120,
        // height: 747,
        alt: 'P-Boote bei viel Wind',
        // srcset: [
        //   'assets/img/xs/pboot1.webp 688w',
        //   'assets/img/sm/pboot1.webp 912w',
        //   'assets/img/md/pboot1.webp 1120w',
        //   'assets/img/lg/pboot1.webp 1200w',
        //   'assets/img/xl/pboot1.webp 1200w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/dn3.jpg',
    //     // width: 5400,
    //     // height: 3821,
    //     alt: 'Eissegeln mit DN-Schlitten at the top.',
    //     // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    {
      img: {
        src: 'assets/img/regatta1.jpg',
        // width: 1919,
        // height: 1080,
        alt: 'Siegerehrung im YSTM',
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/pram1.jpg',
    //     // width: 1120,
    //     // height: 747,
    //     alt: 'Pram der WVSTM',
    //     // srcset: [
    //     //   'assets/img/xs/pram1.webp 688w',
    //     //   'assets/img/sm/pram1.webp 912w',
    //     //   'assets/img/md/pram1.webp 1120w',
    //     //   'assets/img/lg/pram1.webp 1360w',
    //     //   'assets/img/xl/pram1.webp 2320w',
    //     // ],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    {
      img: {
        src: 'assets/img/pram3.jpg',
        // width: 1120,
        // height: 747,
        alt: 'Pram der WVSTM',
        // srcset: [
        //   'assets/img/xs/pram1.webp 688w',
        //   'assets/img/sm/pram1.webp 912w',
        //   'assets/img/md/pram1.webp 1120w',
        //   'assets/img/lg/pram1.webp 1360w',
        //   'assets/img/xl/pram1.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
  ];

  /** depreciated tiles */
  // public tiles: YsCarouselTile[] = [
  //   {
  //     img: {
  //       src: 'assets/img/md/pboot2.webp',
  //       width: 1120,
  //       height: 742,
  //       alt: 'P-Boot Regatta',
  //       srcset: [
  //         'assets/img/xs/pboot2.webp 688w',
  //         'assets/img/sm/pboot2.webp 912w',
  //         'assets/img/md/pboot2.webp 1120w',
  //         'assets/img/lg/pboot2.webp 1360w',
  //         'assets/img/xl/pboot2.webp 2320w',
  //       ],
  //       sizes: ['90vw'],
  //       priority: true,
  //     }
  //   },
  //   {
  //     img: {
  //       src: 'assets/img/md/ausklang-2015-1.webp',
  //       width: 1120,
  //       height: 630,
  //       alt: 'Cat Ausklang',
  //       style: 'width:100%;height:100%;object-fit:cover;object-position:50% 60%;',
  //       srcset: [
  //         'assets/img/xs/ausklang-2015-1.webp 688w',
  //         'assets/img/sm/ausklang-2015-1.webp 912w',
  //         'assets/img/md/ausklang-2015-1.webp 1120w',
  //         'assets/img/lg/ausklang-2015-1.webp 1360w',
  //         'assets/img/xl/ausklang-2015-1.webp 2320w',
  //       ],
  //       sizes: ['90vw'],
  //       loading: 'lazy',
  //     }
  //   },
  //   {
  //     img: {
  //       src: 'assets/img/md/pboot1.webp',
  //       width: 1120,
  //       height: 747,
  //       alt: 'P-Boote bei viel Wind',
  //       srcset: [
  //         'assets/img/xs/pboot1.webp 688w',
  //         'assets/img/sm/pboot1.webp 912w',
  //         'assets/img/md/pboot1.webp 1120w',
  //         'assets/img/lg/pboot1.webp 1200w',
  //         'assets/img/xl/pboot1.webp 1200w',
  //       ],
  //       sizes: ['90vw'],
  //       loading: 'lazy',
  //     }
  //   },
  //   {
  //     img: {
  //       src: 'assets/img/md/pram1.webp',
  //       width: 1120,
  //       height: 747,
  //       alt: 'Pram der WVSTM',
  //       srcset: [
  //         'assets/img/xs/pram1.webp 688w',
  //         'assets/img/sm/pram1.webp 912w',
  //         'assets/img/md/pram1.webp 1120w',
  //         'assets/img/lg/pram1.webp 1360w',
  //         'assets/img/xl/pram1.webp 2320w',
  //       ],
  //       sizes: ['90vw'],
  //       loading: 'lazy',
  //     }
  //   },
  // ];
  // public tiles: YsCarouselTile[] = [
  //   {styleClass: 'carRegatta1'},
  //   {styleClass: 'carRegatta2'},
  //   {styleClass: 'carRegatta3'},
  //   {styleClass: 'carRegatta4'},
  // ]

}
